<template id="navbar-search-wrapper">
  <div class="relative">
    <div class="relative d-inline">
      <input class="transition focus:outline-0 border border-transparent focus:bg-white focus:border-grey-light placeholder-grey-darkest rounded bg-grey-lighter py-2 pr-4 pl-10 block w-full appearance-none leading-normal"
        type="text"
        placeholder="Zoeken naar een object.."
        v-model="query"
        @input="isEmpty()"
        @keyup.enter="done($event)"
        @keyup.backspace="resetPage">
    </div>

    <div class="pointer-events-none absolute pin-y pin-l pl-3 flex items-center">
      <svg class="fill-current pointer-events-none text-grey-dark w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"></path></svg>
    </div>

    <div class="absolute pin-r pin-y pr-3 flex items-center" v-show="showRemove">
      <span @click="reset()" class="no-lineheight text-xl text-grey-darker hover:text-grey-darkest font-semibold cursor-pointer">
        &times;
      </span>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import subject from '@/store/modules/subject';

if (!store.state.subject) store.registerModule('subject', subject);

import { mapState } from 'vuex';

export default {
  template: '#navbar-search-wrapper',
  name: 'NavbarSearch',
  data() {
    return {
      query: '',
      searched: false,
      isPageReset: false
    };
  },
  methods: {
    reset() {
      this.query = '';
      this.searched = false;
      this.fetch();
    },
    resetPage() {
      if (!this.isPageReset) {
        this.$store.commit('subject/setFilters', {
          key: 'page',
          value: 1
        });

        this.isPageReset = true;
      }
    },
    isEmpty() {
      if (this.searched && this.query.length === 0) {
        this.reset();
      }
    },
    fetch(value = null) {
      this.$store.commit('subject/setFilters', {
        key: 'filter[q]',
        value: value
      });
      return this.$store.dispatch('subject/fetchAll');
    },
    async done(event) {
      if (this.query.length < 3) return;

      this.searched = true;
      this.isPageReset = false;

      await this.fetch(this.query);

      event.target.blur();

      if (this.$route.name !== 'home') {
        return this.$router.push({ name: 'home' });
      }
    }
  },
  computed: {
    ...mapState({
      filters: state => state.subject.filters
    }),
    showRemove() {
      return this.query.length >= 3;
    }
  },
  watch: {
    $route: function(to, from) {
      if (to.name != 'home' && from.name == 'home') {
        this.reset();
      }
    },
    filters: {
      handler: function(value) {
        if (!value['filter[q]']) {
          this.query = '';
        }
      },
      deep: true
    }
  }
};
</script>
